import React from 'react';
import { Box, Stack } from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';
import ExperienceItem from './ExperienceItem';
import { IExperienceGroup } from './types';

export default function ExperienceGroup({
  experienceGroup
}: {
  experienceGroup: IExperienceGroup;
}) {
  return (
    <Stack direction="row" spacing={1}>
      <Box
        sx={{
          padding: '8px',
          height: '44px',
          border: '1px solid #E3E3E3',
          background: '#ffffff',
          zIndex: 1
        }}
      >
        <BusinessIcon sx={{ height: '24px', width: '24px' }} />
      </Box>
      <Stack direction="column" spacing={2} sx={{ flex: 1, minWidth: 0 }}>
        {experienceGroup.experiences.map((experience, index) => (
          <ExperienceItem
            key={index}
            experience={experience}
            company={index === 0 ? experienceGroup.company : null}
          />
        ))}
      </Stack>
    </Stack>
  );
}
